// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/master_catalog",
    element: lazy(() => import("../pages/ManageCatalog/index.js")),
  },
];

export default routes;
